<div [class.loading-overlay]="loading">
  <table>
    <thead>
      <tr>
        <th class="sr-only" [innerHTML]="(textkeyPrefix + 'kategorie') | translate"></th>
        <th class="sr-only" [innerHTML]="(textkeyPrefix + 'wert') | translate"></th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td [innerHTML]="(textkeyPrefix + 'gesamt') | translate"></td>
        <td aria-live="polite">@if(costs) {{{(costs.overall.sum * 1) | number: '1.0-0'}} €}</td>
      </tr>
      <tr class="border">
        <td [innerHTML]="(textkeyPrefix + 'energie.zukuenftig') | translate"></td>
        <td aria-live="polite">@if(costs) {{{ (anfrage.measureResult.costs.financing[financing].wirtschaftlichkeit.energiekosten_monat) | number: '1.0-0' }} €}</td>
      </tr>
      <tr class="border">
        <td [innerHTML]="(textkeyPrefix + 'energie.heute') | translate"></td>
        <td aria-live="polite">@if(costs) {{{ (anfrage.measureResult.demand.wirtschaftlichkeit.energiekosten_monat) | number: '1.0-0' }} €}</td>
      </tr>
    </tbody>
  </table>
  <button type="button" class="details-button" (click)="onShowDetails()" [innerHTML]="'moderat.sanierung.show_details' | translate"></button>
</div>
